import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[shouldOpenTooltip]',
  exportAs: 'shouldOpenTooltip',
})
export class ShouldOpenTooltipDirective implements OnChanges {
  @Input()
  shouldOpenTooltip: boolean;

  constructor(private tooltip: NgbTooltip) {
    tooltip.triggers = null;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if ('shouldOpenTooltip' in changes) {
      if (this.shouldOpenTooltip) {
        this.tooltip.open();
      } else {
        this.tooltip.close();
      }
    }
  }
}
